import React from 'react';
import { ShieldCheck, FlaskConical, Lock, Package } from 'lucide-react';

/**
 * Trust badges strip — shown in CartSidebar and Checkout to reduce drop-off.
 * variant: 'compact' (cart sidebar) | 'full' (checkout)
 */
const TrustBadges = ({ variant = 'compact' }) => {
  const badges = [
    { icon: <ShieldCheck size={variant === 'compact' ? 16 : 20} />, label: '98%+ Purity', sub: 'per CoA' },
    { icon: <FlaskConical size={variant === 'compact' ? 16 : 20} />, label: 'Independent Lab', sub: 'Tested' },
    { icon: <Lock size={variant === 'compact' ? 16 : 20} />, label: 'Encrypted', sub: 'Checkout' },
    { icon: <Package size={variant === 'compact' ? 16 : 20} />, label: 'Discreet', sub: 'Shipping' },
  ];

  if (variant === 'compact') {
    return (
      <div
        data-testid="trust-badges-compact"
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(4, 1fr)',
          gap: '8px',
          padding: '12px',
          background: 'rgba(0, 229, 255, 0.04)',
          border: '1px solid rgba(0, 229, 255, 0.15)',
          borderRadius: '8px',
          margin: '12px 0'
        }}
      >
        {badges.map((b, i) => (
          <div key={i} className="flex flex-col items-center text-center gap-1">
            <div style={{ color: '#00B8D4' }}>{b.icon}</div>
            <div style={{ fontSize: '10px', fontWeight: 600, color: 'var(--text-primary)', lineHeight: 1.1 }}>
              {b.label}
            </div>
            <div style={{ fontSize: '9px', color: 'var(--text-secondary)', lineHeight: 1 }}>
              {b.sub}
            </div>
          </div>
        ))}
      </div>
    );
  }

  // Full variant — checkout
  return (
    <div
      data-testid="trust-badges-full"
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))',
        gap: '14px',
        padding: '20px',
        background: 'var(--bg-secondary)',
        border: '1px solid var(--border-light)',
        borderRadius: '8px',
        margin: '20px 0'
      }}
    >
      {badges.map((b, i) => (
        <div key={i} className="flex items-center gap-3">
          <div
            style={{
              width: '40px',
              height: '40px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              background: 'rgba(0, 229, 255, 0.1)',
              borderRadius: '50%',
              color: '#00B8D4',
              flexShrink: 0
            }}
          >
            {b.icon}
          </div>
          <div>
            <div style={{ fontSize: '13px', fontWeight: 600, color: 'var(--text-primary)' }}>{b.label}</div>
            <div style={{ fontSize: '11px', color: 'var(--text-secondary)' }}>{b.sub}</div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default TrustBadges;
